<template>
  <v-dialog v-model="modelMessage" :width="width" :persistent="persistent" v-on:update:modelValue="fecharAction">
    <v-card>
      <v-card-title class="bg-color-1 text-color-white font-weight-bold">{{ title }}</v-card-title>
      <v-card-text class="pa-3 text-color-0">
        <div v-html="message"></div>
      </v-card-text>
      <v-card-actions class="d-flex justify-end">
        <v-btn v-if="response != null" variant="tonal" class="bg-red text-color-white cy-dialogmessage-nao" @click="action(false);">
          Não
        </v-btn>
        <v-btn v-if="response != null" variant="tonal" class="bg-green text-color-white cy-dialogmessage-sim" @click="action(true);">
          Sim
        </v-btn>
        <v-btn v-if="response == null" variant="tonal" class="bg-color-2 text-color-white cy-dialogmessage-ok" @click="fecharAction()">
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'DialogMessage',
  data(){
    return {
      modelMessage: false
    }
  },
  props: {
    model: {
      type: Boolean,
      default: false
    },
    persistent: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: "350px"
    },
    title: {
      type: String,
      default: ""
    },
    message: {
      type: String,
      default: ""
    },
    fechar: {
      type: Function,
      default: null
    },
    response: {
      type: Function,
      default: null
    }
  },
  watch: {
    model() {
      this.modelMessage = this.model
    }
  },
  methods: {
    action(b){
      this.response(b);
      this.fechar();
    },
    fecharAction(){
      this.fechar();
    }
  }
}
</script>